<template>
  <div class="market-product-add">
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('button.addProduct')" @backReturn="backReturn"></NavHeaderBar>
    <van-search v-model="searchVal" :placeholder="$t('form.searchBrandOrProduct')" @input="getSearchSuggFn" />
    <div class="brand-section">
      <div class="brand-header">
        <span>{{ $t('shared.filter.brandFilter') }}</span>
        <van-icon name="arrow-down" @click="selectShow=true" />
      </div>
      <van-tabs type="card" color="#307bff" v-model="tabActive" @change="handleTab">
        <van-tab v-for="item in tabsList" :title="item" :key="item" :name="item"></van-tab>
      </van-tabs>
    </div>
    <div class="product-section">
      <div class="product-item" :class="{'active-product-item': checkId.rivalId === item.rivalId, 'disable-product-item': disableId.includes(item.rivalId)}" v-for="(item) in productList" :key="item.rivalId" @click="handleOper(item)">
        <div class="product-name">{{ item.productName }}</div>
        <div class="other-name">
          <span>{{ item.brand }} · {{ item.series }}</span>
          <span>{{ item.category }}</span>
        </div>
      </div>
    </div>
    <div class="detail-btn">
      <van-button class="more-btn" @click="handleSubmit('cancel')">{{ $t('button.cancel') }}</van-button>
      <van-button class="current-btn" @click="handleSubmit('confirm')">{{ $t('button.confirm') }}</van-button>
    </div>
    <van-popup v-model="selectShow" position="bottom" :round="true" :style="{ 'max-height': '566px', 'min-height': '266px' }" get-container="#app">
      <div class="other-content">
        <div class="filter-popup-title">{{ $t('shared.filter.filter') }}</div>
        <div class="filter-popup-content" style="max-height: 436px; min-height: 266px">
          <div v-for="(otherItem, otherIndex) in brandList" :class="{'active-status': tabActive === otherItem }" @click="changeVal(otherItem)" :key="otherIndex" class="item-content">
            {{ otherItem }}
          </div>
        </div>
        <div class="operate-btn">
          <van-button type="primary" @click="handleFilter('reset')">{{ $t('button.reset') }}</van-button>
          <van-button class="confirm-btn" type="primary" @click="handleFilter('confirm')">{{ $t('button.confirm') }}</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { supportRivalListApi } from '@/api/marketInsight'
import { Toast } from 'vant'
export default {
  name: 'MarketProductAdd',
  data () {
    return {
      searchVal: '',
      disableCheckList: [],
      productList: [],
      selectShow: false,
      brandList: [],
      tabActive: this.$t('shared.filter.all'),
      checkId: {}
    }
  },
  activated () {
    this.tabActive = this.$t('shared.filter.all')
    this.checkId = {}
    const selected = sessionStorage.getItem('selectedProducts')
    this.getRivalList()
    if (selected) {
      this.disableCheckList = JSON.parse(selected)
    }
  },
  computed: {
    // 自动处理：超过8个取前8个，不足则全显示
    tabsList () {
      return this.brandList.slice(0, 8)
    },
    disableId () {
      return this.disableCheckList.map(subItem => subItem.rivalId)
    }
  },
  methods: {
    handleOper (item) {
      if (this.disableId.includes(item.rivalId)) return
      if (this.checkId.rivalId === item.rivalId) {
        this.checkId = {}
      } else {
        this.checkId = item
      }
    },
    handleSubmit (type) {
      if (type === 'cancel') {
        this.checkId = {}
      }
      this.backReturn()
      this.$router.go(-1)
      // if (type === 'confirm') {
      //   sessionStorage.setItem('selectedProducts', JSON.stringify(this.currentCheckList))
      //   this.$router.go(-1)
      // } else if (type === 'cancel') {
      //   this.$router.go(-1)
      // }
    },
    getRivalList () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      const data = {
        search: this.searchVal,
        brandName: this.tabActive === this.$t('shared.filter.all') ? '' : this.tabActive
      }
      supportRivalListApi(data).then(res => {
        Toast.clear()
        const { brandList, rivalList } = res.data
        rivalList.forEach((subItem, subIndex) => {
          // subItem.rivalId = subItem.rivalId + subIndex
          subItem.avgMonthSale = ''
          subItem.campaignPolicy = ''
          subItem.exwEstimatePrice = ''
          subItem.marketFeedback = ''
          subItem.mdDealerPrice = ''
          subItem.retailPrice = ''
          subItem.storePurchasePrice = ''
          subItem.supplyRatio = ''
          subItem.supplyExwPrice = ''
        })
        this.productList = rivalList
        brandList.unshift(this.$t('shared.filter.all'))
        this.brandList = brandList
      })
    },
    changeVal (params) {
      this.tabActive = params
    },
    handleFilter (type) {
      if (type === 'reset') {
        this.tabActive = this.$t('shared.filter.all')
      }
      this.getRivalList()
      this.selectShow = false
    },
    handleTab (name, title) {
      this.getRivalList()
    },
    getSearchSuggFn () {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        clearTimeout(this.timer)
        this.timer = null
        this.getRivalList()
      }, 500)
    },
    backReturn () {
      sessionStorage.removeItem('selectedProducts') // 清理数据
      let arr = []
      if (this.checkId.rivalId) {
        arr = [...this.disableCheckList, this.checkId]
      } else {
        arr = this.disableCheckList
      }
      sessionStorage.setItem('selectedProducts', JSON.stringify(arr))
    }
  }
}
</script>

<style lang="less" scoped>
.market-product-add {
  display: flex;
  flex-direction: column;
  height: 100%;
  .van-search__content {
    border-radius: 10px;
  }
  .brand-section {
    padding: 12px;
    border-top: 1px solid #e2e1e1;
    border-bottom: 1px solid #e2e1e1;
    .brand-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }
    /deep/.van-tabs {
      .van-tabs__nav {
        margin: 0;
        border: none !important;
      }
      .van-tab {
        border: none;
        border-radius: 20px;
        background-color: #f3f4f6;
        color: #000 !important;
        font-size: 12px;
        margin-right: 5px;
        &:last-child {
          margin-right: 0;
        }
      }
      .van-tab--active {
        color: #fff !important;
      }
    }
  }
  .product-section {
    flex: 1;
    overflow-y: auto;
    padding: 10px 12px;
    .product-item {
      padding: 10px;
      margin-bottom: 5px;
      border: 1px solid #e2e1e1;
      border-radius: 8px;
      .product-name {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 8px;
      }
      .other-name {
        display: flex;
        justify-content: space-between;
        color: #7f7f7f;
      }
      &:last-child {
        margin-bottom: 0px;
      }
    }
    .active-product-item {
      border: 1px solid #619aff;
      background-color: #eff6ff;
    }
    .disable-product-item {
      border: 1px solid #e2e1e1;
      background-color: rgba(192, 192, 192, 0.3);
    }
  }
  .detail-btn {
    display: flex;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    .current-btn,
    .more-btn {
      flex: 1;
      border: none;
      font-weight: bold;
    }
    .current-btn {
      background-color: #307bff;
      color: #fff;
    }
    .more-btn {
      color: #000;
    }
  }
}
.other-content {
  padding: 10px 18px 20px 18px;
  .filter-popup-title {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    margin-bottom: 10px;
  }
  .filter-popup-content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    align-content: start;
    overflow: auto;
    .item-title {
      width: 100%;
      color: #000;
      font-weight: bold;
      font-size: 12px;
      padding: 7px 0;
    }
    .item-content {
      width: 48%;
      height: 27px;
      color: #000;
      text-align: center;
      line-height: 27px;
      font-size: 11px;
      background-color: #f3f6fc;
      border-radius: 6px;
      margin-top: 5px;
      margin-bottom: 5px;
      // padding: 0 5px;
      margin-right: 5px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .active-status {
      background-color: #1989fa;
      color: #fff;
    }
    .project-item {
      display: flex;
      align-items: center;
      padding: 10px;
      height: 47px;
      font-size: 12px;
      border-bottom: 1px solid #dce5f6;
    }
    .choice-active {
      color: #307bff;
    }
  }
  .operate-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    justify-content: space-between;
    /deep/.van-button {
      width: 126px;
      height: 40px;
      background-color: #dce5f6;
      border: 1px solid #dce5f6;
      border-radius: 8px;
      color: #000;
    }
    .confirm-btn {
      width: 190px;
      color: #fff;
      background-color: #307bff;
      border: 1px solid #307bff;
    }
  }
}
</style>
